export default {
    'redeemPoint.title': 'ポイント交換',
    'redeemPoint.collect_success': 'ポイント付与成功',
    'redeemPoint.redeem_success': 'ポイント交換成功',
    'redeemPoint.redeem_fail': 'ポイント交換失敗',
    'redeemPoint.point_not_enough': 'ポイントが不足しているため、交換できません',
    'redeemPoint.please_enter_quantity': 'ポイント数を入力してください',
    'redeemPoint.next_step': '次へ',
} as Record<string, string>;
